export default {
	title: "",
	subtitle: "",
  path: "webhooks_disable",
	paragraph: " If you want to disable all notifications, just make a request using the endpoint below ",
	request:  {
		method: "GET", 
		endpoint: "/disable_webhooks",
		responses: {
			"data": "ok"
		},
	},
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/DisableWebhooks.js